import axios from 'axios';
import configSingletonInstance from 'src/ConfigSingleton';

const instance = axios.create({
  withCredentials: true,
});
instance.defaults.params = {};

instance.interceptors.request.use(config => {
  config.baseURL =
    configSingletonInstance.getConfig().REACT_APP_BASE_URL;
  return config;
});
export default instance;
